export default __webpack_public_path__ + "static/media/menuProfile.70a02313.svg";